export const LISTING_GROUP_PERF_MARKER = 'Listing_Group';
export const LISTING_GROUP_TREE_ROUTING = '/campaign/vnext/listinggroups/hierarchy';
export const LISTING_GROUP_LIST_ROUTING = '/campaign/vnext/listinggroups/list';
export enum GridType {
  List = 'List',
  Tree = 'Tree',
}
export const GRID_NAME = 'ListingGroupGrid';
export const columnChooserId = 'dropdown-column-chooser';
export enum ScopeLevel {
  Campaign = 'campaign',
  AssetGroup = 'assetGroup',
}
export const nameColumnOdataPath = 'Condition/Attribute';

export const treeViewButtonId = 'button-hierarchy-view';

export const listViewButtonId = 'button-list-view';

export const firstColumnName = 'primary';
export const conversionsFiledName = 'conversions';
export const impressionsFiledName = 'impressions';
export const clicksFiledName = 'clicks';
export const hotelsFiledName = 'hotels';

export const EVERYTHING_ELSE_NODE_ATTRIBUTE = '';

export type NullPartial<T> = {
  [P in keyof T]: T[P] | null;
};
